module.exports = __webpack_public_path__ + "static/media/ad-notification-imglink-mockup-upper.075653e6.png";